import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { complianceApi } from '../api/compliance';
import type { ComplianceControlUpdate } from '../types';

export function useComplianceSummary() {
  return useQuery({
    queryKey: ['compliance', 'summary'],
    queryFn: complianceApi.getSummary,
    staleTime: 30_000,
  });
}

export function useUpdateComplianceControl() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, updates }: { id: string; updates: ComplianceControlUpdate }) => complianceApi.updateControl(id, updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['compliance', 'summary'] });
    },
  });
}
